import { DynamicSelectData } from "@/shared/components/DynamicSelect/model/DynamicSelectData";
import { ListOfPropertiesValues } from "./ListOfPropertiesValues";
import { ServiceTemplateService } from "@/modules/ServiceTemplate/services/ServiceTemplateService";
import { Http } from "@status/codes";
import { FIELD_WITHOUT_DATA } from "@/modules/DashboardTemplate/constants/DashboardTemplatesConstants";
import { FORM_MESSAGES } from "@/shared/constants/FormConstants";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import store from "@/store";

export class ServicesPropertiesValues extends ListOfPropertiesValues {
  cups = this.findCups;
  serviceTemplate = this.getServiceTemplates;
  sections = this.getSections;
  groups = this.getGroups;
  lastDocId = "";
  keyword = "";
  indexSectionOfDashboard = 0;
  indexCollection = 0;

  async loadItems(
    field: string,
    idList?: string,
    keyWord?: string,
    lastDocId?: string
  ) {
    this.lastDocId = lastDocId || "";
    console.log("field", field);
    if (keyWord) {
      return (await this[field as keyof ServicesPropertiesValues](
        keyWord
      )) as DynamicSelectData[];
    }

    if (this.keyword) {
      this.keyword = "";
    }

    if (idList) {
      return this.getList(idList);
    }

    return await this[field as keyof ServicesPropertiesValues]();
  }

  findCups() {
    return this.getCups();
  }

  setIndexes(
    indexSectionOfDashboard: number,
    indexCollectionFilter: number
  ): void {
    this.indexSectionOfDashboard = indexSectionOfDashboard;
    this.indexCollection = indexCollectionFilter;
  }

  async getServiceTemplates() {
    try {
      const serviceTemplateService = new ServiceTemplateService();
      const response = await serviceTemplateService.getAllActiveServiceTemplate();
      if (response.code === Http.Found && response.data) {
        const serviceTemplatesList: DynamicSelectData[] = [];
        response.data.forEach(({ id, internalName }) => {
          serviceTemplatesList.push({
            id: id as string,
            name: internalName
          });
        });
        serviceTemplatesList.push(FIELD_WITHOUT_DATA);
        return { data: serviceTemplatesList };
      }
    } catch (error) {
      Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async addSectionsOrGroups(valueOfField: { id: string; name: string }[]) {
    console.log("addSectionsOrGroups dentro de services", valueOfField);
    const serviceTemplateService = new ServiceTemplateService();
    const response = await serviceTemplateService.getServiceTemplateById(
      valueOfField[0].id
    );
    console.log("response", response);
    if (response.code === Http.Found && response.data) {
      if (response.data.type == "sections") {
        store.commit("setDataToUseInValuesSelect", {
          id: "sections",
          data: response.data.sections
        });

        return [
          {
            data: {
              id: "sections",
              name: "Secciones",
              fields: response.data.sections
            },
            function: "addNewField"
          },
          {
            data: {
              id: "groups",
              name: "Grupos"
            },
            function: "removeField"
          }
        ];
      }
      store.commit("setDataToUseInValuesSelect", {
        id: "groups",
        data: response.data.groups
      });
      return [
        {
          data: {
            id: "groups",
            name: "Grupos",
            fields: response.data.groups
          },
          function: "addNewField"
        },
        {
          data: {
            id: "sections",
            name: "Secciones"
          },
          function: "removeField"
        }
      ];
    }
  }

  getSections() {
    const data = store.getters.getDataToUseInValuesSelect.sections.map(
      (section: any) => ({ id: section.key, name: section.name })
    );
    return { data };
  }
  getGroups() {
    const data = store.getters.getDataToUseInValuesSelect.groups.map(
      (group: any) => ({ id: group.key, name: group.name })
    );
    return { data };
  }
}
